

import { sanPhamChiTietApi } from '../../../api/san-pham/sanPhamChiTietApi';
import { ISanPhamImportRequest } from '../../../model/request/san-pham/ISanPhamImportRequest';
import { IBaseRespone } from '../../../model/respone/IBaseRespone';
import { ISanPhamChiTiet } from '../../../model/respone/san-pham/ISanPhamChiTiet';
import { eSanPhamChiTietActionTypeIds, ISanPhamChiTietActions } from '../../action-types/san-pham/ISanPhamChiTietActionType';
import { rootActions } from '../../actions/rootActions';

import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
const mainAction = rootActions.sanPham.sanPhamChiTiet;
export function* sanPhamChiTietChiTietSaga(): any {
    yield takeLatest(eSanPhamChiTietActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eSanPhamChiTietActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eSanPhamChiTietActionTypeIds.DELETE_START, deleteWorker)
    yield takeEvery(eSanPhamChiTietActionTypeIds.SAVE_IMPORT_CHITIET_START, saveImportWorker)
}

function* loadWorker(action: ISanPhamChiTietActions): any {
    const payload = action.payload as { dm_coso_id?: number; uf_kho_id?: number } | undefined;
    const cosoId = parseInt(localStorage.getItem("dm_coso_id") ?? "0") || 0;
    const khoId = parseInt(localStorage.getItem("uf_kho_id") ?? "0") || 0;

    const requestParams: { dm_coso_id: number; uf_kho_id: number } = {
        dm_coso_id: payload?.dm_coso_id || cosoId,
        uf_kho_id: payload?.uf_kho_id || khoId,
    };

    const res: IBaseRespone = yield call(sanPhamChiTietApi.SelectAllWithInventory, requestParams);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveWorker(action: ISanPhamChiTietActions): any {
    let res: IBaseRespone;
    const SanPhamChiTiet = action.payload as ISanPhamChiTiet;
    if (SanPhamChiTiet.id > 0) {
        res = yield call(sanPhamChiTietApi.Update, SanPhamChiTiet)
    } else {
        res = yield call(sanPhamChiTietApi.Insert, SanPhamChiTiet)
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data))
        // Reload lại danh sách sản phẩm chi tiết sau khi save thành công
        yield put(mainAction.LOAD_START(undefined))
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* deleteWorker(action: ISanPhamChiTietActions): any {
    const res: IBaseRespone = yield call(sanPhamChiTietApi.Delete, action.payload as number)
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data))
        // Reload lại danh sách sản phẩm chi tiết sau khi xóa thành công
        yield put(mainAction.LOAD_START(undefined))
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveImportWorker(action: ISanPhamChiTietActions): any {
    const res: IBaseRespone = yield call(sanPhamChiTietApi.SaveDataExcel, action.payload as ISanPhamImportRequest)
    if (res.is_success) {
        yield put(mainAction.SAVE_IMPORT_CHITIET_SUCCESS(res.data.data_uploaded || res.data))
        // Reload lại danh sách sản phẩm chi tiết sau khi import thành công
        yield put(mainAction.LOAD_START(undefined))
    } else {
        yield put(mainAction.SAVE_IMPORT_CHITIET_ERROR(res.message ?? "Có lỗi"))
    }
}
